<template>
  <div class="loader">
    <PageLoading />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import PageLoading from "@/components/PageLoading.vue";

export default defineComponent({
  components: {
    PageLoading,
  },
});
</script>

<style scoped lang="scss">
.loader {
  display: flex;
  flex-direction: row;
  flex: 1;
  .loading {
    width: 100%;
    max-width: $document-max-width;
    padding: 76px 0 0;
    padding-inline-start: 100px;
  }
}
</style>
